import ExpandableFeaturesList from './ExpandableFeaturesList'

export default ExpandableFeaturesList
